import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableRow
} from '@/components/ui/table';
import { Card } from '@/components/ui/card';
import { useRegions } from '@/data/region';

import RegionRow from './RegionRow';
import NotFound from '@/components/common/NotFound';

const RegionList = () => {
  const regions = useRegions();

  if (regions.data.length === 0) {
    return <NotFound title="No Regions Found" />;
  }
  return (
    <>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Time Zone</TableHead>
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {regions.data.map((region) => (
              <RegionRow key={region.id} region={region} />
            ))}
          </TableBody>
        </Table>
      </Card>
      <div className="text-center p-4">
        <span className="text-sm text-muted-foreground">
          Total: {regions.data.length}
        </span>
      </div>
    </>
  );
};

export default RegionList;
